module.exports = __webpack_public_path__ + "2acb60f2/img/at-icon.5d6fc5d8.svg";